<template>
  <div class="min-w-0 mr-1">
    <h3 class="fs-4 mb-0">
      <SkeletonLine
        :val="json"
        v-slot:default="{ val }"
        class="flex-grow-1 flex-shrink-0 truncate"
      >
        {{ val.name }}
      </SkeletonLine>
    </h3>
    <p class="mb-0">
      <SkeletonLine
        :val="json"
        v-slot:default="{ val }"
        class="truncate font-normal text-sm text-gray-800 flex-grow-0 leading-tight"
      >
        <template v-if="val.slogan">{{ val.slogan }}</template>
      </SkeletonLine>
    </p>
    <p class="text-sm text-gray-600 mb-0 leading-tight">
      {{ formattedNumUri }}
    </p>
  </div>
</template>

<script>
import SkeletonLine from "@/components/SkeletonLine";

import { formatNumUriString } from "@/utils/utils";

export default {
  name: "FavouriteItemMain",
  components: {
    SkeletonLine,
  },
  props: {
    numUriString: String,
    json: Object,
  },
  computed: {
    formattedNumUri() {
      return formatNumUriString(this.numUriString);
    },
  },
};
</script>
